import { useEffect, useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import {
  useExecutiveDemoMode,
  useExecutiveDemoProtection,
} from "@/lib/executive-demo";

export function ExecutiveDemoOverlay() {
  const active = useExecutiveDemoMode();
  useExecutiveDemoProtection(active);
  const [bannerOpen, setBannerOpen] = useState(true);

  useEffect(() => {
    if (active) setBannerOpen(true);
  }, [active]);

  if (!active) return null;

  return (
    <>
      {/* Watermark grid */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[9998] select-none overflow-hidden"
        style={{ mixBlendMode: "overlay" }}
      >
        <div
          className="absolute -inset-[20%] opacity-[0.07] text-[10px] font-bold tracking-[0.4em] uppercase text-foreground"
          style={{
            transform: "rotate(-20deg)",
            backgroundImage:
              "repeating-linear-gradient(0deg, transparent 0 80px, transparent 80px 160px)",
          }}
        >
          {Array.from({ length: 80 }).map((_, i) => (
            <div key={i} className="whitespace-nowrap py-3">
              {Array.from({ length: 8 })
                .map(
                  () =>
                    "Confidential Demo – Proprietary Technology of VerseSport™",
                )
                .join("   •   ")}
            </div>
          ))}
        </div>
      </div>

      {/* Confidential banner */}
      {bannerOpen && (
        <div className="fixed top-0 inset-x-0 z-[9999] bg-gradient-to-r from-amber-600/95 via-red-600/95 to-amber-600/95 text-white shadow-2xl">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-1.5 text-[11px] font-bold tracking-wide">
            <div className="flex items-center gap-2">
              <ShieldAlert className="h-3.5 w-3.5" />
              <span>
                This demonstration contains proprietary and confidential technology.
              </span>
            </div>
            <button
              onClick={() => setBannerOpen(false)}
              className="opacity-80 hover:opacity-100"
              aria-label="Dismiss"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}